import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { useActivityTeacherUpsellListing } from "@outschool/ui-components-website";
import React from "react";

import { MobileActivityListComponent } from "../../listings/MobileActivityList";

export const TeacherSuggestList = ({
  activity,
  leader,
}: {
  activity: ClassDetailsNoSectionsQuery["activity"];
  leader: NonNullable<ClassDetailsNoSectionsQuery["activity"]["leader"]>;
}) => {
  const upsellListing = useActivityTeacherUpsellListing(activity);
  const { t } = useTranslation(
    "client\\components\\detailPage\\mobileBelowClassDetail",
  );

  return (
    <>
      {!!upsellListing && (
        <MobileActivityListComponent
          lists={[upsellListing]}
          title={t("{{teacherName}} suggests this class next...", {
            teacherName: leader.name,
          })}
        />
      )}
    </>
  );
};
